module.exports = __webpack_public_path__ + "media/images/our_apps/smart_tv_md-ff8c94e448133369a787b97dc4fb2a7a.png";